import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="modal"
export default class extends Controller {

  static values = {state: Boolean, autoOpen: Boolean}
  static targets = ["showModalButton", "modalContainer"]

  connect() {
    if (this.autoOpenValue) {
        this.presentModal(null);
    }
  }

  presentModal(event) {
    this.stateValue = true;
    this.modalContainerTarget.classList.remove("opacity-0", "pointer-events-none");
    this.modalContainerTarget.classList.remove("animate-fade-out");
    this.modalContainerTarget.classList.add("animate-fade-in");
  }

  dismissModal(event) {
    if (!this.stateValue) {
      return;
    }
    if (event) {
      event.preventDefault()
    }
    this.stateValue = false;
    this.modalContainerTarget.classList.remove("animate-fade-in");
    this.modalContainerTarget.classList.add("animate-fade-out");
  }

  dismissOutsideModal(event) {
    if (!this.stateValue) {
      return;
    }
    if (event) {
      if (!event.target.matches('#outsideModalId')){
        return;
      }
    }
    this.stateValue = false;
    this.modalContainerTarget.classList.remove("animate-fade-in");
    this.modalContainerTarget.classList.add("animate-fade-out");
  }

  dismissModalWithoutPrevent(event) {
    if (!this.stateValue) {
      return;
    }
    this.stateValue = false;
    this.modalContainerTarget.classList.remove("animate-fade-in");
    this.modalContainerTarget.classList.add("animate-fade-out");
  }
}
